import styled from "styled-components/macro";
import {useState} from "react";
import {useHistory} from "react-router-dom";
import {Button, FormControl, Input, Select, Switch, useToast} from "@chakra-ui/react";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import NavLink from "../../components/nav_link";
import {useQuery} from "../../utils/router";
import {useActions, useModal, useSettings} from "../../store";
import ToggleField from "../../components/toggle_field";
import TextField from "../../components/text_field";
import MultichoiceField from "../../components/multichoice_field";
import {useSetPassword} from "../../api/password";
import {useSetEmail} from "../../api/email";
import {useDeleteAccount} from "../../api/delete_account";
import {usePurge} from "../../api/purge";
import useLogout from "../../api/logout";
import {useBlock} from "../../api/user";
import {usePaymentHistory, useSubscriptionStatus} from "../../api/payments";
import CancelProSubscription from "../../components/CancelProSubscription";
import IncreaseProSubscriptionPrice from "../../components/IncreaseProSubscriptionPrice";
import PayWithCrypto from "../../components/subscriptions/pay_with_crypto";
import {isPseudoCommunity} from "../../store/communites";
import useWindowDimensions from "../../utils/dimensions";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import {themecolors} from "../../utils/themecolors";
import {useCreateImage, useUploadToken} from "../../api/create_image";
import {
    Bell,
    Brush,
    CreditCard,
    Lock,
    Palette,
    User,
    UserRoundX,
    VenetianMask,
    Delete as LucideDelete,
    Eraser
} from "lucide-react";
import FileUpload from "../../components/file_upload";

const Heading = styled.div``;
const Item = styled.div``;
const Manage = styled.div``;
const Sort = styled.div``;
const CategoryHeading = styled.div``;
const Save = styled.div``;
const SidebarModule = styled.div``;
const List = styled.div``;
const ListItem = styled.div``;

const PageHeading = styled.div``;
const SectionHeading = styled.div``;

const SwitchHeading = styled.div``;
const SwitchDescription = styled.div``;
const SwitchContainer = styled.div``
const SwitchText = styled.div``;
const SwitchItem = styled.div``;
const Text = styled.div``;
const TextHeading = styled.div``;

const Info = styled.div``;

const Buttons = styled.div``;

const MobileSettings = styled.div``;
const MobileSetting = styled.div``;

const themeOptions = [
    {value: 'light', label: `Light`},
    {value: 'dark', label: `Dark`},
];

const postViewOptions = [
    {value: "condensed", label: `Condensed`},
    {value: "card", label: `Card`},
];

const commentSortOptions = [
    {value: "old", label: `Old`},
    {value: "new", label: `New`},
    {value: "controversial", label: `Worst`},
    {value: "top", label: `Top`},
];

const Basic = styled(({className, settings, apply}) => {
    return (
        <div className={className}>
            <PageHeading>
                General
            </PageHeading>
            <SectionHeading>
                Post View in Feeds
            </SectionHeading>
            <p>'Card View' shows embeddable content such as images and videos by default, while 'Condensed View' hides
                it behind an extra click.</p>
            <Select value={settings.expand} maxWidth='350' mt='12px' mb='24px' onChange={(value) => apply({expand: value.target.value})}>
                <option value='card'>Card</option>
                <option value='condensed'>Condensed</option>
            </Select>
            <SectionHeading>
                Post View in Threads
            </SectionHeading>
            <p>This setting applies when inside a thread, which is when there's a single post and the comment replies on
                screen.</p>
            <Select value={settings.expand_thread ? 'card' : 'condensed'} maxWidth='350' mt='12px' mb='24px' onChange={(value) => apply({expand_thread: value.target.value === 'card'})}>
                <option value='card'>Card</option>
                <option value='condensed'>Condensed</option>
            </Select>
            <SectionHeading>
                Comment Sort
            </SectionHeading>
            <p>This setting sets the default sorting method for a comment thread, and can be overridden when looking at
                a thread.</p>
            <Select value={settings.comment_sort} maxWidth='350' mt='12px' mb='24px' onChange={(value) => apply({comment_sort: value.target.value})}>
                <option value='old'>Old</option>
                <option value='new'>New</option>
                <option value='controversial'>Worst</option>
                <option value='top'>Top</option>
            </Select>

            <SectionHeading style={{marginBottom: '16px'}}>
                More Settings
            </SectionHeading>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Back to Top</SwitchHeading>
                    <SwitchDescription>
                        You'll see a shortcut to return to the top of the page.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.scroll_top}
                            onChange={(value) => apply({scroll_top: !settings.scroll_top})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Hide Upvoted Posts</SwitchHeading>
                    <SwitchDescription>
                        Posts will be hidden from feeds after upvoting.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.hide_upvoted}
                            onChange={(value) => apply({hide_upvoted: !settings.hide_upvoted})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Show NSFW Content</SwitchHeading>
                    <SwitchDescription>
                        Images which are potentially unsafe will be blurred.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.show_nsfw}
                            onChange={(value) => apply({show_nsfw: !settings.show_nsfw})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Infinite Scrolling</SwitchHeading>
                    <SwitchDescription>
                        New posts will load endlessly as you scroll.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.infinite_scroll}
                            onChange={(value) => apply({infinite_scroll: !settings.infinite_scroll})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Links in New Tabs</SwitchHeading>
                    <SwitchDescription>
                        External post links will open in new tabs.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.new_tab}
                            onChange={(value) => apply({new_tab: !settings.new_tab})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Beta Features</SwitchHeading>
                    <SwitchDescription>
                        You might see features which are not released.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.beta}
                            onChange={(value) => apply({beta: !settings.beta})} />
                </SwitchItem>
            </SwitchContainer>

        </div>
    )
})`
  ${MultichoiceField} {
    margin-bottom: 16px;
  }
  h2 {
    margin-bottom: 0;
    font-size: 16px;
  }

  p {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }`;

const Profile = styled(({className}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const [picture, setPicture] = useState(null);

    const uploadToken = useUploadToken(feedbackCh);

    const [saving, setSaving] = useState(false);const setProfilePicture = useCreateImage(feedbackCh);

    const toast = useToast();

    const handleUpload = async (picture) => {
        try {
            if (!saving) {
                setSaving(true);
                toast({
                    title: `Saving...`,
                    status: 'info',
                    isClosable: true,
                });
                if (picture) {
                    const token = await uploadToken('profilePicture');
                    await setProfilePicture(picture, token);
                }
                toast({
                    title: `Updated profile picture.`,
                    status: 'success',
                    isClosable: true,
                });
                setSaving(false);
            }
        } catch {
        }
    };

    const handleChange = (file) => {
        const f = event.target.files[0];
        setPicture(f);
        handleUpload(f);
    };

    return (
        <div className={className}>
            <PageHeading>
                Profile
            </PageHeading>

            <SectionHeading>Profile Picture</SectionHeading>

            <p>Please refer to the <a href={"https://help.scored.co/knowledge-base/profile-picture-policy/"} target={"_blank"}>Profile Picture policy</a> before
                uploading.</p>

            <FormControl>
                <FileUpload onChange={handleChange} selectedFile={picture} />
            </FormControl>

        </div>
    )
})`
  h2 {
    margin-bottom: 0;
    font-size: 16px;
  }
  
  p {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    margin-bottom: 16px;
  }

  ${TextField} {
    margin-top: 12px;
  }
`;

const Appearance = styled(({className, settings, apply}) => {
    return (
        <div className={className}>
            <PageHeading>
                Appearance
            </PageHeading>

            <SectionHeading>
                Base Style
            </SectionHeading>
            <p>
                If enabled, we'll show the selected community's custom style on any otherwise unstyled pages.
            </p>

            <Text>
                <Input placeholder='Cats' value={settings.community_styling} onChange={(value) => apply({community_styling: value.target.value})} />
            </Text>

            <SectionHeading style={{marginBottom: '16px', marginTop: '24px'}}>
                More Settings
            </SectionHeading>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Community Styling</SwitchHeading>
                    <SwitchDescription>
                        Communities may apply their own custom CSS styling.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.custom_styling}
                            onChange={(value) => apply({custom_styling: !settings.custom_styling})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Dark Mode</SwitchHeading>
                    <SwitchDescription>
                        The platform will appear darker.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.theme === 'dark'}
                            onChange={(value) => apply({theme: (settings.theme !== 'dark') ? 'dark' : 'light'})} />
                </SwitchItem>
            </SwitchContainer>

        </div>
    )
})`
  h2 {
    margin-bottom: 0;
    font-size: 16px;
  }

  p {
    margin-top: 4px;
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${TextField} {
    margin-top: 12px;
  }
`;

const Notifications = styled(({className, settings, apply}) => {
    return (
        <div className={className}>
            <PageHeading>
                Notifications
            </PageHeading>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Username Pings</SwitchHeading>
                    <SwitchDescription>
                        You'll receive a notification when another user tags you.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.username_pings}
                            onChange={(value) => apply({username_pings: !settings.username_pings})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Comment Replies</SwitchHeading>
                    <SwitchDescription>
                        You'll receive a notification when your comment gets a reply.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.notify_comments}
                            onChange={(value) => apply({notify_comments: !settings.notify_comments})} />
                </SwitchItem>
            </SwitchContainer>

        </div>
    )
})``;

const Privacy = styled(({className, settings, apply}) => {
    return (
        <div className={className}>
            <PageHeading>
                Privacy
            </PageHeading>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Index on Search Engines</SwitchHeading>
                    <SwitchDescription>
                        Your profile will be indexed by search engines.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.index_profile}
                            onChange={(value) => apply({index_profile: !settings.index_profile})} />
                </SwitchItem>
            </SwitchContainer>

            <SwitchContainer>
                <SwitchText>
                    <SwitchHeading>Accept Private Messages</SwitchHeading>
                    <SwitchDescription>
                        Users will be able to send you private messages.
                    </SwitchDescription>
                </SwitchText>
                <SwitchItem>
                    <Switch isChecked={settings.accept_private_messages}
                            onChange={(value) => apply({accept_private_messages: !settings.accept_private_messages})} />
                </SwitchItem>
            </SwitchContainer>

        </div>
    )
})``;

const Purge = styled(({className}) => {

    const [password, setPassword] = useState('');
    const {error, feedbackCh} = useFeedback();
    const purge = usePurge(feedbackCh);
    const history = useHistory();
    const toast = useToast();
    const handlePurge = async () => {
        try {
            await purge(password);
            history.push('/');
            toast({
                title: `Your content has been purged.`,
                status: 'success',
                isClosable: true,
            });
        } catch {
        }
    };

    return (
        <div className={className}>
            <PageHeading>
                Purge Content
            </PageHeading>
            <p>Purging your content will:</p>
            <ul>
                <li>irreversibly impact your data across all of our websites and communities</li>
                <li>remove all posts, comments, messages, and edit revisions from our database immediately</li>
            </ul>
            <p>It will not:</p>
            <ul>
                <li>restrict future access to your account</li>
                <li>immediately remove any information from our exported database backups</li>
                <li>immediately remove all posts, comments, messages, and edit revisions from our cache servers, which
                    means the purged content may remain available on our websites for several minutes after your content
                    is purged.
                </li>
            </ul>
            <p>To purge your content, confirm your password below.</p>

            <TextHeading>
                Confirm Password
            </TextHeading>

            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={password} onChange={(value) => setPassword(value.target.value)} />
            </Text>

            {error && error.toString()}
            <Button variant='blue' onClick={handlePurge}>Purge Content</Button>
        </div>
    )
})`
${TextHeading} {
  margin-top: 16px;
}
${Text} {
  margin-top: 6px;
  margin-bottom: 12px;
}`;

const Delete = styled(({className}) => {

    const [password, setPassword] = useState('');
    const {error, feedbackCh} = useFeedback();
    const deleteAccount = useDeleteAccount(feedbackCh);
    const logout = useLogout(feedbackCh);
    const history = useHistory();
    const handleDeleteAccount = async () => {
        try {
            await deleteAccount(password);
            await logout();
            history.replace('/');
        } catch {
        }
    };

    return (
        <div className={className}>
            <PageHeading>
                Delete Account
            </PageHeading>
            <p>Deleting your account will:</p>
            <ul>
                <li>impact your account across all of our websites and communities</li>
                <li>irreversibly and immediately prevent any further logins to your account</li>
                <li>remove all posts, comments, messages, and edit revisions from our database immediately</li>
                <li>remove sensitive account information from our servers immediately, including your email address
                    hash, IP address hashes, and password hash.
                </li>
            </ul>
            <p>It will not:</p>
            <ul>
                <li>immediately remove any information from our exported database backups</li>
                <li>immediately remove all posts, comments, messages, and edit revisions from our cache servers, which
                    means the deleted content may be available on our websites for several minutes after your account is
                    deleted.
                </li>
            </ul>
            <p>To delete your account, confirm your password below.</p>

            <TextHeading>
                Confirm Password
            </TextHeading>

            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={password} onChange={(value) => setPassword(value.target.value)} />
            </Text>

            {error && error.toString()}
            <Button variant='blue' onClick={handleDeleteAccount}>Delete Account</Button>
        </div>
    )
})`
  ${TextHeading} {
    margin-top: 16px;
  }
  ${Text} {
    margin-top: 6px;
    margin-bottom: 12px;
  }`;

const Subscription = styled(({className}) => {

    const modal = useModal();
    const pro_tier = 0;
    const pro_expire = 0;

    const {error, feedbackCh} = useFeedback();
    const subscription = useSubscriptionStatus(feedbackCh);

    const handleCancel = () => {
        modal.open(CancelProSubscription);
    };

    const handleIncreasePrice = () => {
        modal.open(IncreaseProSubscriptionPrice, {currentPrice: subscription.price});
    };

    const handleRenew = () => {
        modal.open(PayWithCrypto, {renew: true});
    };

    return (
        <div className={className}>
            <PageHeading>
                Subscription
            </PageHeading>
            {error &&
                <>
                    <p>You do not have an active paid subscription.</p>
                    <p style={{paddingTop: '8px'}}>For billing issues, please contact support@scored.co</p>
                </>
            }

            {subscription &&
                <>
                    <CategoryHeading>
                        <h2>Monthly Cost</h2>
                    </CategoryHeading>
                    <p>${subscription.price}</p>
                    <CategoryHeading>
                        <h2>Payment Method</h2>
                    </CategoryHeading>
                    <p>{subscription.source === "card" ? "Credit / Debit Card" : "Cryptocurrency"}</p>
                    <CategoryHeading>
                        <h2>Renewal Date</h2>
                    </CategoryHeading>
                    <p>{new Date(subscription.expiryDate).toLocaleDateString()}</p>
                    {subscription.userCancelled ? <p style={{marginTop: 8}}>This subscription will cancel on the renewal date.</p> :
                        <Buttons>
                            <Button variant='grey' mt='6px' mr='8px' onClick={() => subscription.source === "card" ? handleCancel() : handleRenew()}>
                                {subscription.source === "card" ? "Cancel" : "Renew"}
                            </Button>
                            <Button variant='blue' mt='6px'
                                    onClick={() => handleIncreasePrice()}>
                                Edit Price
                            </Button>
                        </Buttons>
                    }
                </>
            }
        </div>
    )
})`
  ${CategoryHeading} {
    margin-top: 12px;
  }

  ${CategoryHeading}:first-of-type {
    margin-top: 0;
  }
${Buttons} {
  margin-top: 18px;
  display: flex;
  width: 260px;
}`;


const Payments = styled(({className}) => {
    const {error, feedbackCh} = useFeedback();
    const paymentHistory = usePaymentHistory(feedbackCh);
    return (
        <div className={className}>
            <PageHeading>
                Payments
            </PageHeading>
            {paymentHistory?.length === 0 &&
                <p>You have not made any payments.</p>
            }
            {paymentHistory?.map((payment) => (
                <p key={payment.id}>payment</p>
            ))}
        </div>
    )
})``;

const Security = styled(({className}) => {

    const toast = useToast();
    const [settings, setSettings] = useState({
        password_old: '',
        password_new: '',
        password_confirm: '',
        email_password: '',
        email_email: '',
    });
    const set = (name) => (value) => setSettings((settings) => ({...settings, [name]: value}));

    const {error: emailError, feedbackCh: emailFeedbackCh} = useFeedback();
    const {error: passwordError, feedbackCh: passwordFeedbackCh} = useFeedback();
    const setPassword = useSetPassword(passwordFeedbackCh);
    const handleSetPassword = async () => {
        try {
            await setPassword(settings.password_old, settings.password_new, settings.password_confirm);
            toast({
                title: `Your password has been changed.`,
                status: 'success',
                isClosable: true,
            });
        } catch {
        }
    };

    const setEmail = useSetEmail(emailFeedbackCh);
    const handleSetEmail = async () => {
        try {
            await setEmail(settings.email_password, settings.email_email);
            toast({
                title: `Your email has been changed.`,
                status: 'success',
                isClosable: true,
            });
        } catch {
        }
    };

    return (
        <div className={className}>
            <PageHeading>
                Security
            </PageHeading>
            <SectionHeading style={{paddingBottom: '8px'}}>Change Your Password</SectionHeading>

            <p>Set a new password to be used for future logins. Changing your password will not invalid existing sessions.</p>

            <TextHeading>
                Current Password
            </TextHeading>

            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={settings.password_old} onChange={(value) => set('password_old')(value.target.value)} />
            </Text>

            <TextHeading>
                New Password
            </TextHeading>

            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={settings.password_new} onChange={(value) => set('password_new')(value.target.value)} />
            </Text>

            <TextHeading>
                Repeat New Password
            </TextHeading>

            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={settings.password_confirm} onChange={(value) => set('password_confirm')(value.target.value)} />
            </Text>

            {passwordError && passwordError.toString()}
            <Button variant='blue' onClick={handleSetPassword} mb='24px' mt={'16px'}>Save</Button>
            <SectionHeading style={{paddingBottom: '8px'}}>
                Add a Recovery Email Address
            </SectionHeading>
            <p>We do not store raw email addresses. If you need to perform a password reset in the future, we'll ask you
                to confirm your email address, and if it matches the hash value that we have stored, we will
                send an email to the address provided.</p>

            <TextHeading>
                Current Password
            </TextHeading>
            <Text>
                <Input autoComplete={'off'} type={'password'} placeholder='********' required
                       maxLength='64' value={settings.email_password} onChange={(value) => set('email_password')(value.target.value)} />
            </Text>

            <TextHeading>
                Email Address
            </TextHeading>
            <Text>
                <Input autoComplete={'off'} type={'text'} placeholder='you@example.com' required
                       maxLength='64' value={settings.email_email} onChange={(value) => set('email_email')(value.target.value)} />
            </Text>
          
            {emailError && emailError.toString()}
            <Button variant='blue' onClick={handleSetEmail} mt={'16px'}>Save</Button>
        </div>
    )
})`
  ${CategoryHeading}:first-of-type h2 {
    margin-top: 4px;
  }

  ${CategoryHeading} h2 {
    margin-top: 24px;
  }

  p {
    margin-bottom: 12px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }
  ${TextHeading} {
    margin-top: 16px;
  }
`;

const BlockedUser = styled(({className, username}) => {
    const {feedbackCh} = useFeedback();
    const block = useBlock(feedbackCh);
    const handleUnblock = async () => {
        try {
            await block(username);
        } catch {
        }
    };
    return (
        <tr className={className}>
            <td><NavLink href={`/u/${username}`} react_route>{username}</NavLink></td>
            <td>
                <Info onClick={handleUnblock}>
                    Unblock
                </Info>
            </td>
        </tr>
    )
})`
    ${Info} {
      margin-left: 8px;
      font-weight: 500;
      cursor: pointer;
    }
`;

const Block = styled(({className}) => {

    const {blocked} = useSettings();

    return (
        <div className={className}>

            <PageHeading>
                Blocked Users
            </PageHeading>

            {blocked && blocked.map((username) => (
                <BlockedUser key={username} username={username}/>
            ))}
            {blocked?.length === 0 && <p>You haven't blocked any users yet.</p>}

        </div>
    )
})`
  ${TextHeading} {
    margin-top: 16px;
  }
  ${Text} {
    margin-top: 6px;
    margin-bottom: 12px;
  }`;

const SettingsSidebar = styled(({type, className}) => {
    const {username} = useSettings();
    return (
        <div className={className}>
            <SidebarModule>
                <Heading>
                    Account Settings
                </Heading>
                <List>
                    <NavLink href={'?type=basic'} react_route>
                        <ListItem className={type === 'basic' && 'active'}>
                            <User size={20} />
                            General
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=profile'} react_route>
                        <ListItem className={type === 'profile' && 'active'}>
                            <Brush size={20} />
                            Profile
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=appearance'} react_route>
                        <ListItem className={type === 'appearance' && 'active'}>
                            <Palette size={20} />
                            Appearance
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=notifications'} react_route>
                        <ListItem className={type === 'notifications' && 'active'}>
                            <Bell size={20} />
                            Notifications
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=privacy'} react_route>
                        <ListItem className={type === 'privacy' && 'active'}>
                            <VenetianMask size={20} />
                            Privacy
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=security'} react_route>
                        <ListItem className={type === 'security' && 'active'}>
                            <Lock size={20} />
                            Security
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=subscription'} react_route>
                        <ListItem className={type === 'subscription' && 'active'}>
                            <CreditCard size={20} />
                            Subscription
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=blocked'} react_route>
                        <ListItem className={type === 'blocked' && 'active'}>
                            <UserRoundX size={20} />
                            Blocked Users
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=purge'} react_route>
                        <ListItem className={type === 'purge' && 'active'}>
                            <Eraser size={20} />
                            Purge Content
                        </ListItem>
                    </NavLink>
                    <NavLink href={'?type=delete'} react_route>
                        <ListItem className={type === 'delete' && 'active'}>
                            <LucideDelete size={20} />
                            Delete Account
                        </ListItem>
                    </NavLink>
                </List>
            </SidebarModule>
        </div>
    );
})`
  flex: 0 0 300px;
  ${SidebarModule} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    padding: 16px 0;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ${Heading} {
    margin-bottom: 12px;
    padding: 0 24px;
    font-weight: 600;
  }
  ${List} {
    margin: 0 16px;
    font-size: 15px;
  }
  ${ListItem} {
    padding: 12px 0 12px 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 4px;
  }
  ${ListItem}:hover {
    background-color: #80808012;
    border-radius: 4px;
  }
  ${ListItem} svg {
    margin-right: 12px;
  }
  ${ListItem}.active {
    background-color: #80808012;
    border-radius: 4px;
  }
`;

const Settings = styled(({className}) => {

    const community = useBaseCommunity();
    const style = useCommunityStyle(community);

    const {type = "basic"} = useQuery();

    const actions = useActions();
    const settings = useSettings();
    const apply = (changes) => {
        actions.settingsChanged(changes);
    };

    const {width} = useWindowDimensions();

    return (
        <div className={className}>
            <HeaderData title={"Settings"} community={community} community_style={style}/>
            <Header>
                {(community !== "TheDonald" || width <= 780) && <TopBar legacyConversion={community === "TheDonald"} page={'Settings'}/>}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                    </>
                }
                {community === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container forceWidth={"slim"}>
                {width > 780 && <SettingsSidebar type={type} />}
                <Wrapper>
                    {width <= 780 &&
                        <MobileSettings>
                            <NavLink href={"/settings"} active={type === "basic"} react_route>
                                General
                            </NavLink>
                            <NavLink href={"/settings?type=profile"} react_route>
                                Profile
                            </NavLink>
                            <NavLink href={"/settings?type=appearance"} react_route>
                                Appearance
                            </NavLink>
                            <NavLink href={"/settings?type=notifications"} react_route>
                                Notifications
                            </NavLink>
                            <NavLink href={"/settings?type=privacy"} react_route>
                                Privacy
                            </NavLink>
                            <NavLink href={"/settings?type=security"} react_route>
                                Security
                            </NavLink>
                            <NavLink href={"/settings?type=subscription"} react_route>
                                Subscription
                            </NavLink>
                            <NavLink href={"/settings?type=purge"} react_route>
                                Purge
                            </NavLink>
                            <NavLink href={"/settings?type=delete"} react_route>
                                Delete
                            </NavLink>
                            <NavLink href={"/settings?type=blocked"} react_route>
                                Blocked
                            </NavLink>
                        </MobileSettings>
                    }
                    <Main>
                        {type === 'basic' && <Basic settings={settings} apply={apply}/>}
                        {type === 'profile' && <Profile settings={settings} apply={apply}/>}
                        {type === 'appearance' && <Appearance settings={settings} apply={apply}/>}
                        {type === 'notifications' && <Notifications settings={settings} apply={apply}/>}
                        {type === 'privacy' && <Privacy settings={settings} apply={apply}/>}
                        {type === 'security' && <Security settings={settings} apply={apply}/>}
                        {type === 'subscription' && <Subscription/>}
                        {type === 'payments' && <Payments/>}
                        {type === 'purge' && <Purge/>}
                        {type === 'delete' && <Delete/>}
                        {type === 'blocked' && <Block/>}
                    </Main>
                </Wrapper>
            </Container>
            <Footer/>
        </div>
    );
})`
  ${MobileSettings} {
    display: flex;
    align-items: center;
    padding: 12px 16px 0px 16px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    overflow: scroll;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  ${MobileSettings}::-webkit-scrollbar {
    display: none;
  }
  ${MobileSetting} {
    cursor: pointer;
    flex-shrink: 0;
    font-size: 15px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
    padding: 6px 16px;
    margin-right: 8px;
    border-radius: 48px;
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  ${MobileSetting}.active {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.light_high_impact_text : themecolors.dark_high_impact_text};
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.dark_background_1};
  }
  ${MobileSettings} a {
    cursor: pointer;
    flex-shrink: 0;
    font-size: 15px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_6 : '#eaeaea'};
    padding: 6px 16px;
    margin-right: 8px;
    border-radius: 48px;
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_high_impact_text : themecolors.light_high_impact_text};
  }
  ${MobileSettings} .active {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.light_high_impact_text : themecolors.dark_high_impact_text};
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.dark_background_1};
  }

  @media only screen and (min-width: 781px) {
    ${MobileSettings} {
      background-color: transparent;
      padding: 12px 16px;
    }
  }
  ${Wrapper} {
    margin-right: 0;
    margin-left: 12px;
  }
  ${PageHeading} {
    font-size: 19px;
    font-weight: 600;
    margin-bottom: 12px;
  }
  ${CategoryHeading} h2 {
    font-size: 18px;
  }

  ${TextField} label,
  ${MultichoiceField} label {
    margin-top: 8px;
    font-weight: 500;
  }

  ${TextField}, ${MultichoiceField}, ${Text} {
    width: 350px;
    max-width: 100%;
  }
  ${Text} {
    margin-top: 6px;
  }

  ${MultichoiceField} label {
    font-size: 15px;
  }

  ${Main} {
    padding: 24px;
    font-size: 15px;
  }

  ${Heading} {
    margin-right: 32px;
  }

  ${Item} {
    margin-right: 24px;
  }

  ${Manage} {
    display: flex;
    font-size: 14px;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 12px;
    overflow-y: auto;
    white-space: nowrap;
  }

  ${Item} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Sort} {
    margin-left: auto;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
  }

  ${Sort} svg {
    margin-left: 8px;
  }

  ${Manage} ${Item} .active {
    color: ${({theme}) => theme.sort.active};
    font-weight: 600;
  }

  ${ToggleField} {
    margin-bottom: 16px;
  }

  ${ToggleField}:last-of-type {
    margin-bottom: 0;
  }

  ${ToggleField} span,
  ${MultichoiceField} span {
    margin-left: 4px;
    font-weight: 400;
    font-size: 14px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${MultichoiceField} {
    margin-top: 12px;
    margin-bottom: 24px;
  }

  ${Save} {
    margin-top: 16px;
    text-align: right;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
    width: 350px;
    max-width: 100%;
    font-weight: 600;
  }
  
  ${SectionHeading} {
    font-size: 15px;
    font-weight: 600;
  }
  ${TextHeading} {
    font-size: 15px;
    font-weight: 600;
  }
  
  ${SwitchDescription} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${SwitchContainer} {
    width: 450px;
    max-width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 16px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 15px;
  }
  ${SwitchDescription} {
    font-size: 14px;
  }
  ${SwitchItem} {
    margin-left: auto;
  }
  
  ${Wrapper} {
  
  }
  
  @media only screen and (max-width: 780px) {
    ${Main} {
      padding: 16px;
    }
    ${Wrapper} {
      margin-left: 0;
    }
    ${Container} {
      flex-direction: column;
    }
    ${SettingsSidebar} {
      margin: 8px 0;
    }
  }
`;

export default Settings;
